import { DataRelationshipDto, DataTableReference, RelationshipCardinality } from 'src/app/services/api.services';
import { DataField } from './DataField';
import { DataTable } from './DataTable';

export class DataRelationship {
  constructor(
    public readonly from: DataField,
    public readonly to: DataField,
    public cardinality: RelationshipCardinality,
    public nonNull: boolean) { }

  readonly reference: DataRelationshipReference = {
    fromTable: this.from.table.reference,
    toTable: this.to.table.reference,
  };

  readonly key: DataRelationshipKey = {
    fromTable: this.from.table,
    toTable: this.to.table,
  };

  get fromTable() { return this.from.table; }
  get toTable() { return this.to.table; }

  toDto(): DataRelationshipDto {
    return {
      from: this.from.reference,
      to: this.to.reference,
      cardinality: this.cardinality,
      nonNull: this.nonNull,
    };
  }
}

export interface DataRelationshipReference {
  readonly fromTable: DataTableReference;
  readonly toTable: DataTableReference;
}

export interface DataRelationshipKey {
  readonly fromTable: DataTable;
  readonly toTable: DataTable;
}
